import { useMutation } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { useSnackbar } from 'notistack';
import { useAvContext } from '../context/AvContextProvider';
import { downloadURI } from '../utils/utils';

const GET_PRESIGNED_URL = gql`
  query getPresignedUrl($objectKeys: String!) {
    getPresignedUrl(objectKeys: $objectKeys)
  }
`;

const GET_QUERY_PRESIGNED_URL = gql`
  query getExportQueryPresignedUrl($wfId: String!, $runId: String!) {
    getExportQueryPresignedUrl(wfId: $wfId, runId: $runId)
  }
`;

const GET_PRESIGNED_URL_FROM_TEMPORAL_WF = gql`
  query getPresignedUrlFromTemporalWorkflow($wfId: String!, $runId: String!, $metadataKey: String) {
    getPresignedUrlFromTemporalWorkflow(wfId: $wfId, runId: $runId, metadataKey: $metadataKey)
  }
`;

export enum PresignedUrlType {
  REGULAR = 'REGULAR',
  QUERY = 'QUERY',
  FROM_TEMPORAL_WF = 'FROM_TEMPORAL_WF',
}

export const gplPresignedUrlType = {
  [PresignedUrlType.REGULAR]: GET_PRESIGNED_URL,
  [PresignedUrlType.QUERY]: GET_QUERY_PRESIGNED_URL,
  [PresignedUrlType.FROM_TEMPORAL_WF]: GET_PRESIGNED_URL_FROM_TEMPORAL_WF,
};

export const usePresignedUrl = (type: PresignedUrlType = PresignedUrlType.REGULAR, name?: string, target?: string) => {
  const { api } = useAvContext();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<Record<string, string>, string, PresignedUrlObjectKeys | PresignedUrlWorkflowResult>({
    mutationFn: value => api(gplPresignedUrlType[type], { options: value, muteErrors: true }),
    onError: (err: any) => {
      enqueueSnackbar(`Failed to download: ${err.message}`, { variant: 'error' });
    },
    onSuccess: ({ data, errors }) => {
      if (!errors) {
        downloadURI(Object.values(data)[0], name, target);
      }
    },
  });
};

type PresignedUrlObjectKeys = { objectKeys: string };

type PresignedUrlWorkflowResult = { wfId: string; runId: string; metadataKey?: string | null };
